export default "__VITE_PUBLIC_ASSET__fdcd9a36__"